import { Fragment, useContext } from "react";
import { FormattedMessage } from "react-intl";
import { Grid } from "@mui/material";
import { Add, Remove } from "@mui/icons-material";

import { formatItem } from "@framework/exchange";
import { StyledListItem } from "@framework/styled";
import { Button, List, Typography } from "@dzambalaorg/ui-kit";

import { CartContext } from "../../../../components/providers/cart";
import { StyledListSubheader, StyledPaper } from "./styled";

export const Cart = () => {
  const cart = useContext(CartContext);

  return (
    <StyledPaper>
      <Typography component="h4" variant="h5">
        <FormattedMessage id="pages.checkout.products" />
      </Typography>
      <List disablePadding={true}>
        {cart?.items?.length ? (
          cart.items.map(item => (
            <StyledListItem key={item.product.id}>
              <List.ItemText
                primary={item.product.title}
                secondary={<Fragment>{formatItem(item.product.productItems[0].price)}</Fragment>}
              />
              <List.Item>
                <Grid container alignItems="center" justifyContent="center">
                  <Button
                    intent="icon"
                    aria-label="delete"
                    size="small"
                    onClick={cart.alter(item.amount - 1, item.product)}
                  >
                    <Remove />
                  </Button>
                  <Typography>{item.amount}</Typography>
                  <Button
                    intent="icon"
                    aria-label="add"
                    size="small"
                    onClick={cart.alter(item.amount + 1, item.product)}
                  >
                    <Add />
                  </Button>
                </Grid>
              </List.Item>
            </StyledListItem>
          ))
        ) : (
          <StyledListItem>
            <FormattedMessage id="pages.checkout.empty" />
          </StyledListItem>
        )}
        <StyledListSubheader>
          <FormattedMessage
            id="pages.checkout.total"
            values={{
              amount: 100,
            }}
          />
        </StyledListSubheader>
      </List>
    </StyledPaper>
  );
};
